export default "<div class=\"backdropStyle\"></div>\r\n";